import React from "react";
import PropTypes from 'prop-types';
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import styles from "./PbsDroppingToolbar.module.css";
import MonthPicker from "../MonthPicker/MonthPicker";
import { Button } from "@material-ui/core";
import { callFunctionConditionallyWithWarningCurry } from "../../utils/utils";


const PbsDroppingToolbar = ({ plantName, handleMonthSelect, activeMonthNameWithYear, useCalendar = false, selectedDate, handleDateSelect, onSummaryClick }) => {
  return (
    <>
      <div className={styles.RgtTools}>
        <div className={styles.eAgsnToolbar}>
          {useCalendar ? (
            <>
              <span className={styles.dateLabel}>Select Date</span>
              <KeyboardDatePicker
                autoOk
                variant="inline"
                inputVariant="outlined"
                format="DD/MM/YYYY"
                value={selectedDate}
                InputAdornmentProps={{ position: "start" }}
                onChange={date => handleDateSelect(date)}
                // disableFuture
                style={{ width: '170px' }}
                InputProps={{
                  style: { height: '30px', padding: '0 14px', fontSize: '14px' }
                }}
              />
            </>
          ) : (
            <MonthPicker
              handleSelect={callFunctionConditionallyWithWarningCurry(
                handleMonthSelect,
              )}
            />
          )}
          {onSummaryClick && (
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={onSummaryClick}
              style={{ marginLeft: '10px', height: '30px' }}
            >
              Summary
            </Button>
          )}
          <div className={styles.plantName}>Selected Plant - {plantName}</div>
        </div>
      </div>
    </>
  );
};

PbsDroppingToolbar.prototype = {
  handleMonthSelect: PropTypes.func,
  onSummaryClick: PropTypes.func,
}

export default PbsDroppingToolbar;
